import { render, staticRenderFns } from "./HealthrecordLogList.vue?vue&type=template&id=a424c930&"
import script from "./HealthrecordLogList.vue?vue&type=script&lang=js&"
export * from "./HealthrecordLogList.vue?vue&type=script&lang=js&"
import style0 from "./HealthrecordLogList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports